<template>

    <div>
        <!-- NON EDIT MODE -->
        <v-tooltip top color="primary" :disabled="!displayEditInfo" :open-delay="1000">
            <template v-slot:activator="{ on }">

                <div v-if="!editMode"
                     :class="fontClass"
                     v-on="on"
                     style="word-wrap: break-word; opacity: 0.8;"
                     v-html="html">
                </div>

            </template>
            This Disclaimer can be edited in the Sub Panel Landing Page Templates
        </v-tooltip>

        <!-- EDIT MODE -->
        <text-editor v-if="editMode"
                     v-model="useNoticeModel"
                     hint="Disclaimer"
        >
            <div @click="editClicked">

                <div
                    style="word-wrap: break-word; opacity: 0.8;"
                    :class="fontClass"
                    v-html="html">
                </div>
            </div>
        </text-editor>

    </div>

</template>

<script>

import TextEditor from "@/components/UI/TextEditor.vue";
import policyLinkHelperMixin from "@/components/mixins/policyLinkHelperMixin.js";
import colorMixin from "@/components/mixins/colorMixin.js";

export default {

    mixins: [policyLinkHelperMixin, colorMixin],

    components: {
        TextEditor
    },

    props: {
        editMode: {
            type: Boolean,
            required: false,
            default: false,
        },
        useNotice: {
            type: String,
            required: true,
        },
        subPanelId: {
            type: Number,
            required: true,
        },
        locale: {
            type: Object,
            required: true,
        },
        backgroundColor: {
            type: String,
            required: true,
        },
        displayEditInfo: {
            type: Boolean,
            required: false,
            default: false,
        },
        termsAndConditionsUrl: {
            type: String | null,
            required: false,
            default: null
        },
        privacyPolicyUrl: {
            type: String | null,
            required: false,
            default: null
        },
        cookiePolicyUrl: {
            type: String | null,
            required: false,
            default: null
        }
    },

    data() {
        return {
            editorDialogModel: false,
            data: {
                use_notice: null,
            }
        }
    },

    mounted() {
        // Make a copy
        this.data.use_notice = this.useNotice;
    },

    computed: {

        useNoticeModel: {
            get() {
                return this.data.use_notice;
            },
            set(value) {
                this.data.use_notice = value;
                this.$emit('change:translations', this.data);
            }
        },

        html() {
            if (this.useNotice) {

                return this.replaceVariables(
                    this.useNotice,
                    this.getFontClasses(this.backgroundColor),
                    this.subPanelId,
                    this.locale.code,
                    this.termsAndConditionsUrl,
                    this.privacyPolicyUrl,
                    this.cookiePolicyUrl
                );
            }
            return '';
        },

        fontClass() {
            let classes = ['pt-5 pb-5 font-weight body-2'];

            if (this.editMode) {
                classes.push('cursor-pointer');
            }

            if (this.isDarkColor(this.backgroundColor)) {
                classes.push('grey--text text--lighten-1');
            } else {
                classes.push('grey--text text--darken-1');
            }
            return classes.join(' ');
        },
    },

    methods: {

        editClicked() {
            this.editorDialogModel = true;
        },

        cancelClicked() {
            this.editorDialogModel = false;
        }
    }
}
</script>
